import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import TieredInterventionUnitCard from 'components/TieredInterventionUnitCard'
import NavigationHelper from 'layers/navigation/navigationHelper'
import { flattenArrayOfLessonPdfs, resolveLessonSlug } from './helpers'
import { PREVIEW_MODE } from './constants'

export const Lesson = ({
  attempted,
  contentfulLesson,
  dataTestId,
  isDone,
  lessonIndex,
  pathname,
  search,
}) => {
  const { contentItem } = getLessonCollapsibleData(contentfulLesson) || {}
  const { displayTitle = '', description = '' } = contentItem || {}
  const lessonSlug = resolveLessonSlug({ contentfulLesson, lessonIndex })
  const basePath =
    typeof pathname === 'string' ? pathname.replace(/\/+$/g, '') : ''
  const lessonPath = `${basePath}/${lessonSlug}${search || ''}`

  return (
    <div data-testid={dataTestId}>
      <TieredInterventionUnitCard
        description={description}
        isPreviewMode={attempted === PREVIEW_MODE}
        markedComplete={Boolean(isDone)}
        path={lessonPath}
        title={`${lessonIndex}. ${displayTitle}`}
      />
    </div>
  )
}

Lesson.propTypes = {
  attempted: PropTypes.string.isRequired,
  contentfulLesson: PropTypes.object.isRequired,
  dataTestId: PropTypes.string.isRequired,
  gradeTheme: PropTypes.string,
  instance: PropTypes.string,
  isDone: PropTypes.bool,
  isOpen: PropTypes.bool,
  leaf_node_id: PropTypes.string,
  lessonIndex: PropTypes.number.isRequired,
  lessonPdfsArray: PropTypes.array,
  match: PropTypes.object.isRequired,
  navigationEvent: PropTypes.func,
  pathname: PropTypes.string,
  scoId: PropTypes.number,
  search: PropTypes.string,
  selectedLessonABIndex: PropTypes.oneOf([0, 1]),
  setALessonIsOpen: PropTypes.func.isRequired,
  setSelectedLessonIndex: PropTypes.func.isRequired,
  v2_class_registration_id: PropTypes.string,
}

export const getLessonCollapsibleData = (entry = {}) => {
  const contentItem = entry
  const { lessonPdfs, lessonPlan, studentHandout } = entry
  const lessonPdfsArray = flattenArrayOfLessonPdfs([
    lessonPlan,
    studentHandout,
    lessonPdfs,
  ])

  return { contentItem, lessonPdfsArray }
}

const mapStateToProps = ({ router }) => ({
  pathname: router.location.pathname,
  search: router.location.search,
})

export default connect(
  mapStateToProps,
  NavigationHelper.mapDispatchToProps,
)(Lesson)
